import { createFileRoute } from '@tanstack/react-router';
import BookingPaymentLinkPage from '../components/payment/BookingPaymentLinkPage';

export const Route = createFileRoute('/pay/$token')({
  component: BookingPaymentLinkPage,
});
